import http from "@/utils/request/http"
import { BASE } from '@/config/index'

// 获取 Form 数据
export function GetFormList(data: string[]) {
  return http.request({
    url: `${BASE}/portal-base/mgr/form/getFormList`,
    method: 'post',
    data
  })
}

// 表单左侧字段选择列表
export function SelectFieldList(data: string[]) {
  return http.request({
    url: `${BASE}/portal-base/mgr/form/selectFieldList`,
    method: 'post',
    data
  })
}

// 新增表单
export function AddForm(data: string[]) {
  return http.request({
    url: `${BASE}/portal-base/mgr/form/addForm`,
    method: 'post',
    data
  })
}

// 编辑表单
export function EditForm(data: string[]) {
  return http.request({
    url: `${BASE}/portal-base/mgr/form/editForm`,
    method: 'post',
    data
  })
}

// 新增表单
export function GetFormDetail(id: number) {
  return http.request({
    url: `${BASE}/portal-base/mgr/form/getFormDetail?templateId=${id}`,
    method: 'get'
  })
}

// 获取 logic
export function GetLogicField(data: string[]) {
  return http.request({
    url: `${BASE}/portal-base/mgr/form/getLogicField`,
    method: 'post',
    data
  })
}

// 删除表单
export function DeleteForm(id: number) {
  return http.request({
    url: `${BASE}/portal-base/mgr/form/deleteForm?templateId=${id}`,
    method: 'get'
  })
}

// 编辑表单逻辑规则
export function EditLogic(data: string[]) {
  return http.request({
    url: `${BASE}/portal-base/mgr/form/editLogic`,
    method: 'post',
    data
  })
}

// 查询表单逻辑规则
export function GetLogicDetail(id: number) {
  return http.request({
    url: `${BASE}/portal-base/mgr/form/getLogicDetail?templateId=${id}`,
    method: 'get'
  })
}

// 发布表单
export function PublishFrom(data: string[]) {
  return http.request({
    url: `${BASE}/portal-base/mgr/form/publishFrom`,
    method: 'post',
    data
  })
}


// 获取表单模板详情
export function GetFormTemplateDetail(data: string[]) {
  return http.request({
    url: `${BASE}/portal-base/v10/unauth/external/form/getFormDetail`,
    method: 'post',
    data
  })
}

// 提交表单
export function FormSubmit(data: string[]) {
  return http.request({
    url: `${BASE}/portal-base/v10/unauth/external/form/formSubmit`,
    method: 'post',
    data
  })
}

// event提交表单
export function EventSubmit(data: string[]) {
  return http.request({
    url: `${BASE}/portal-content/v11/unauth/external/training/register`,
    method: 'post',
    data
  })
}

// event提交表单
export function FromDownload(id: number) {
  return http.request({
    url: `${BASE}/portal-base/mgr/form/download?templateId=${id}`,
    method: 'get'
  })
}


// 根据邮箱获取报名信息
export function GetRegisterInfo(data: any) {
  return http.request({
    url: `${BASE}/portal-content/v10/unauth/external/training/basicGetRegisterInfoByEmail?customerEmail=${data.email}`,
    method: 'post',
    data
  })
}

// 获取国家列表
export function GetCountryList(id: number) {
  return http.request({
    url: `${BASE}/portal-base/v10/external/unauth/h5/baseData/countryList`,
    method: 'get'
  })
}

export function GetStateList(params: {}) {
  return http.request({
    url: `${BASE}/portal-base/v10/external/unauth/baseData/province/list`,
    method: 'post',
    params
  })
}

// 查询引用字段表单
export function getFormUsedIn(id: number) {
  return http.request({
    url: `${BASE}/portal-base/mgr/form/getFormUsedIn?templateId=${id}`,
    method: 'get'
  })
}
// 获取event自定义表单是否 不可填写
export function GetEditable(data: string[]) {
  return http.request({
    url: `${BASE}/portal-content/v10/unauth/external/training/getEditable`,
    method: 'post',
    data
  })
}

// 保存表单落地页信息
export function saveFormLanding(data: string[]) {
  return http.request({
    url: `${BASE}/portal-base/mgr/form/saveFormLanding`,
    method: 'post',
    data
  })
}